"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DropDownEditor_1 = require("./editors/DropDownEditor");
const TextEditor_1 = require("./editors/TextEditor");
exports.cellEditor = (col, editorProps, value, row, column, rowIndex, columnIndex) => {
    console.log({ col, column, editorProps, row, value });
    const props = editorProps;
    delete props.ref;
    const renderEditor = () => {
        const { editorType } = col;
        switch (editorType) {
            case "text":
                return (react_1.default.createElement(TextEditor_1.TextEditor, Object.assign({}, props, { value: value, row: row, column: column })));
            case "dropdown":
                return (react_1.default.createElement(DropDownEditor_1.DropdownEditor, Object.assign({}, props, { value: value, row: row, column: column })));
        }
    };
    return renderEditor();
};
//# sourceMappingURL=cellEdit.js.map